import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class I1 implements HttpInterceptor {
  private returnUrl: string = "";
  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private router: Router,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private loadingService: LoadingService) { }

  displayError = (title) => {
    this.toastrService.error(title, "Error:", {
      positionClass: 'toast-top-right',
      closeButton: true,
      disableTimeOut: false,
      timeOut: 5000,
      extendedTimeOut: 5000,
    });
  }
  displayWarning = (title) => {
    this.toastrService.warning(title, "", {
      positionClass: 'toast-top-right',
      closeButton: true,
      disableTimeOut: false,
      timeOut: 5000,
      extendedTimeOut: 5000,
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let errorRes: HttpErrorResponse = null;
    let arr: string[] = req.url.split("/");
    let url: string = arr[arr.length - 1];

    this.loadingService.changeCounter(1);

    // extend server response observable with logging
    return next.handle(req).pipe(
      tap(
        // Succeeds when there is a response; ignore other events
        event => {
          if (event.type !== 0) {
            this.loadingService.changeCounter(-1);
          }
        },//ok = event instanceof HttpResponse ? 'succeeded' : '',
        // Operation failed; error is an HttpErrorResponse
        error => {
          errorRes = error;
        }
      ),
      // Log when response observable either completes or errors
      finalize(() => {
        var re = new RegExp('returnUrl', 'g');
        if (re.test(this.router.url) == false ) {
          this.returnUrl = this.router.url;
        }
        
        if (errorRes !== null) {
          this.loadingService.changeCounter(-1);
          if (url === "token") {
            // Error handling in login controller
          } else if ((errorRes.status === 401) || (errorRes.status === 403)) {
            this.loginService.changeExpired(true);
            this.loginService.logout();
            if (this.returnUrl != "") {
              this.router.navigate(['login'], { queryParams: { returnUrl: this.returnUrl } });
            } else {
              this.router.navigate(['login'])
            }
            //this.displayError(errorRes.error.title || errorRes.error);
          } else if ((errorRes.status === 404)) {
            /* If this is a file download not found error, customize it */
            if (this.router.url.split("/")[1] == 'filedownload') {
              errorRes.error.title = "File Not Found. Either it the file requested does not exist or you do not have permissions to download this file.";
            } else {
              this.displayError(errorRes.error.title || errorRes.error);
            }
          }
          else {
            this.displayError(errorRes.error.title || JSON.stringify(errorRes.error));
          }
        }
      })
    );
  }
}
